<template>
  <el-main id="admin-user">
    <h3 class="section-title green-left-head title-margin">ユーザ管理</h3>

    <el-select v-model="mansion" placeholder="Select">
      <el-option
        v-for="item in mansions"
        :key="item.name"
        :label="item.name"
        :value="item._id"
      >
      </el-option>
    </el-select>

    <p>
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="uploadCSV"
        :auto-upload="false"
        :on-success="onSuccess"
        :headers="header"
      >
        <el-button slot="trigger" size="small" type="primary"
          >System.UserCSVファイル選択</el-button
        >
        <el-button
          style="margin-left: 10px;"
          size="small"
          type="success"
          @click="submitUpload"
          >アップロード</el-button
        >
        <div class="el-upload__tip" slot="tip">
          csv files with a size less than 500kb
        </div>
      </el-upload>
    </p>
    <p>
      <el-upload
        class="upload-demo"
        ref="uploaddb"
        :action="uploadCSVdb"
        :auto-upload="false"
        :on-success="onSuccess"
        :headers="header"
      >
        <el-button slot="trigger" size="small" type="primary"
          >DB.UserCSVファイル選択</el-button
        >
        <el-button
          style="margin-left: 10px;"
          size="small"
          type="success"
          @click="submitUploaddb"
          >アップロード</el-button
        >
        <div class="el-upload__tip" slot="tip">
          csv files with a size less than 500kb
        </div>
      </el-upload>
    </p>
    <el-table :data="result.docs" stripe style="width: 100%">
      <el-table-column prop="loginID" label="ID" width="180"> </el-table-column>
      <el-table-column prop="mansion.name" label="マンション名">
      </el-table-column>
      <el-table-column prop="roomNo" label="部屋番号"> </el-table-column>
      <el-table-column prop="email" label="Email"> </el-table-column>
      <el-table-column prop="role.dispName" label="権限"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onEdit(scope.row._id)"
            >編集</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="result.totalDocs"
      :page-size="result.limit"
      @current-change="onCurrentChange"
    >
    </el-pagination>
  </el-main>
</template>

<script>
import authHeader from "../../../services/auth-header";
import MansionService from "../../../services/mansion.service";
import UserService from "../../../services/user.service";

import store from "../../../store";

export default {
  beforeRouteEnter(to, from, next) {
    const currentUser = store.state.auth.user;
    console.log(currentUser);
    if (currentUser && !currentUser.permissions.includes("Admin")) {
      console.log(":401");
      next({ name: "notfound404" });
    } else {
      next();
    }
  },
  data() {
    return {
      uploadCSV: `${process.env.VUE_APP_API_ENDPOINT}/api/user/upload2`,
      uploadCSVdb: `${process.env.VUE_APP_API_ENDPOINT}/api/user/uploaddb`,
      mansions: [],
      mansionsDef: [{ code: "", name: "すべて", _id: "" }],
      mansion: "",
      result: { docs: [] },
    };
  },
  computed: {
    header: function() {
      return authHeader();
    },
  },
  watch: {
    mansion(val) {
      console.log(";;;;");
      console.log(val);
      this.findByDB(val, 1);
    },
  },
  mounted() {
    MansionService.getAll().then(
      response => {
        this.mansions = this.mansionsDef.concat(response.data);
        this.mansion = "";
        this.findByDB("", 1);
        // console.log(this.mansions);
      },
      // eslint-disable-next-line
      error => {
        // console.log(error);
        // this.roles =
        //   (error.response &&
        //     error.response.data &&
        //     error.response.data.message) ||
        //   error.message ||
        //   error.toString();
      },
    );
  },
  methods: {
    onSuccess() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    },
    onEdit(id) {
      console.log(`edit=${id}`);
      this.$router.push({ name: "admin_user_edit", params: { id } });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    submitUploaddb() {
      this.$refs.uploaddb.submit();
    },
    async findByDB(maintionID, page) {
      const res = await UserService.findByDB(maintionID, page);
      this.result = res.data;
    },
    async onCurrentChange(page) {
      // console.log(page);
      this.findByDB(this.mansion, page);
    },
  },
};
</script>

<style></style>
